import CommonState from './CommonState'
import lang from '@/lang'

export default class WorkflowConstants {
  constructor(code, chineseName, englishName, tips) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
    this.tips = tips
  }
}

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

export const BILL_PAYMENT = new CommonState(1, '付款申请单', 'Bill payment')
export const MAKE_INVOICE = new CommonState(2, '开票申请单', 'Make invoice')
export const Job_CHARGE = new CommonState(3, '业务费用申请单', 'Job charge')
export const TEMP_CREDIT = new CommonState(4, '临时信控申请单', 'Temp credit')
export const CHARGE_CHANGE = new CommonState(5, '费用更改申请单', 'Charge change')
export const COLLECT_INVOICE = new CommonState(6, '收票申请单', 'Collect invoice')
export const PARTNER_APPLICATION_FORM = new CommonState(8, '合作伙伴申请单', 'Partner Application Form')
export const CONTRACT_APPLICATION_FORM = new CommonState(9, '合同申请单', 'Contract Application Form')
/**
 * 流程模块
 */
export const WORKFLOW_TYPES = new Set([
  BILL_PAYMENT,
  MAKE_INVOICE,
  Job_CHARGE,
  TEMP_CREDIT,
  CHARGE_CHANGE,
  COLLECT_INVOICE,
  PARTNER_APPLICATION_FORM,
  CONTRACT_APPLICATION_FORM
])

export const MAKE_INVOICE_BILLING = new CommonState(1, '账单申请', 'Bill application')
export const MAKE_INVOICE_INTERNAL_INVOICE = new CommonState(2, '内部发票申请', 'Internal invoice application')

/**
 * 表单子类型
 */
export const MAKE_INVOICE_SUBTYPE_LIST = new Set([
  MAKE_INVOICE_BILLING,
  MAKE_INVOICE_INTERNAL_INVOICE
])

export const COLLECT_INTERNAL_INVOICE = new CommonState(2, '内部发票申请', 'Internal invoice application')

/**
 * 收票表单子类型
 */
export const COLLECT_INVOICE_SUBTYPE_LIST = new Set([
  COLLECT_INTERNAL_INVOICE
])

export const EXPORT_TYPE_PDF = new CommonState('ExportPDF', 'pdf', 'pdf')
export const EXPORT_TYPE_XLS = new CommonState('ExportXLS', 'xls', 'xls')

/**
 * v3导出文件类型
 */
export const EXPORT_TYPE_LIST = new Set([
  EXPORT_TYPE_PDF,
  EXPORT_TYPE_XLS
])

export const APPLICATION_DIMENSION_BILL_PAYMENT = new CommonState(1, '申请单号', 'Request number')
export const APPLICATION_DIMENSION_MAKE_INVOICE = new CommonState(2, '发票ID', 'Invoice id')
export const APPLICATION_DIMENSION_JOB_CHARGE = new CommonState(3, '业务编号', 'Business number')
export const APPLICATION_DIMENSION_BILL = new CommonState(4, '账单编号', 'Bill number')
export const APPLICATION_DIMENSION_COMPANY = new CommonState(5, '合作伙伴编码', 'Company number')
export const APPLICATION_DIMENSION_CONTRACT = new CommonState(6, '合同编号', 'Contract number')
/**
 * 申请维度
 */
export const APPLICATION_DIMENSIONS = new Set([
  APPLICATION_DIMENSION_BILL_PAYMENT,
  APPLICATION_DIMENSION_MAKE_INVOICE,
  APPLICATION_DIMENSION_JOB_CHARGE,
  APPLICATION_DIMENSION_BILL,
  APPLICATION_DIMENSION_COMPANY,
  APPLICATION_DIMENSION_CONTRACT
])

export const ACTOR_TYPE_ROLE = new WorkflowConstants(0, '指定角色', 'role')
export const ACTOR_TYPE_USER = new WorkflowConstants(1, '指定审批人', 'user')
export const ACTOR_TYPE_MANAGER = new WorkflowConstants(2, '指定上级主管', 'manager', lang.t('CargoMsg.Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor'))
export const ACTOR_TYPE_CAST = new WorkflowConstants(3, '指定岗位', 'cast')
/**
 * 流程人员类型
 */
export const ACTOR_TYPES = new Set([
  ACTOR_TYPE_USER, ACTOR_TYPE_ROLE, ACTOR_TYPE_MANAGER, ACTOR_TYPE_CAST
])

export const NOTIFIER_TYPE_ROLE = new WorkflowConstants(0, '指定角色', 'role')
export const NOTIFIER_TYPE_USER = new WorkflowConstants(1, '指定抄送人', 'notifier')
export const NOTIFIER_TYPE_MANAGER = new WorkflowConstants(2, '指定上级主管', 'manager', lang.t('CargoMsg.Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor'))
export const NOTIFIER_TYPE_CAST = new WorkflowConstants(3, '指定岗位', 'cast')
/**
 * 流程人员类型
 */
export const NOTIFIER_TYPES = new Set([
  NOTIFIER_TYPE_USER, NOTIFIER_TYPE_ROLE, NOTIFIER_TYPE_MANAGER, NOTIFIER_TYPE_CAST
])

export const WORKFLOW_PENDING = new CommonState(0, '处理中', 'Processing')
export const WORKFLOW_COMPLETED = new CommonState(1, '已完成', 'Completed')
export const WORKFLOW_CANCEL = new CommonState(2, '已取消', 'canceled')
export const WORKFLOW_DISCARD = new CommonState(3, '已废弃', 'Discarded')
/**
 * 流程状态 0:处理中 ；1:已完成 ；2:已取消 ；3:已废弃
 */
export const WORKFLOW_STATE = new Set([
  WORKFLOW_PENDING, WORKFLOW_COMPLETED, WORKFLOW_CANCEL, WORKFLOW_DISCARD
])
// 付款申请 业务类型(0:SE;1:SI;2:AE;3:AI)
export const BILL_PAYMENT_LOB_SE = new CommonState(0, '海运出口', 'Sea Export')
export const BILL_PAYMENT_LOB_SI = new CommonState(1, '海运进口', 'Sea Import')
export const BILL_PAYMENT_LOB_AE = new CommonState(2, '空运出口', 'Air Export')
export const BILL_PAYMENT_LOB_AI = new CommonState(3, '空运进口', 'Air Import')
/**
 * 流程状态 0:处理中 ；1:已完成 ；2:已取消
 */
export const BILL_PAYMENT_LOBS = new Set([
  BILL_PAYMENT_LOB_SE, BILL_PAYMENT_LOB_SI, BILL_PAYMENT_LOB_AE, BILL_PAYMENT_LOB_AI
])

export const REVOCATION_PROCESS_STATUS_YES = new CommonState(-9, '不可撤销', 'Irrevocable')
export const REVOCATION_PROCESS_STATUS_NO = new CommonState(9, '允许撤销', 'Revocation is allowed')
/**
 * 撤销流程状态
 */
export const REVOCATION_PROCESS_STATUS = new Set([
  REVOCATION_PROCESS_STATUS_YES, REVOCATION_PROCESS_STATUS_NO
])

export const REJECT_PROCESS_STATUS_PREVIOUS = new CommonState(0, '退回上一节点', 'Irrevocable')
export const REJECT_PROCESS_STATUS_BEGIN = new CommonState(1, '退回发起节点', 'Revocation is allowed')
/**
 * 拒绝流程状态
 */
export const REJECT_PROCESS_STATUS = new Set([
  REJECT_PROCESS_STATUS_PREVIOUS, REJECT_PROCESS_STATUS_BEGIN
])

export const NODE_TYPE_SINGLE = new WorkflowConstants(0, '单例审批', 'single', lang.t('CargoMsg.Cargo_AnyApproverCanHandle'))
export const NODE_TYPE_SIGN = new WorkflowConstants(1, '并行（汇签）', 'sign', lang.t('CargoMsg.Cargo_AllApproversAtCurrentNodeRequired'))
/**
 * 审批人执行方式
 */
export const NODE_TYPES = new Set([
  NODE_TYPE_SINGLE, NODE_TYPE_SIGN
])

export const TRIGGER_TYPE_FINANCE = new CommonState(1, '财务', 'finance')
export const TRIGGER_TYPE_CUSTOMER = new CommonState(2, '客户', 'customer')
export const TRIGGER_TYPE_CONTRACT = new CommonState(3, '合同', 'contract')
export const TRIGGER_TYPE_BUSINESS = new CommonState(4, '业务', 'business')
/**
 * 触发类型，1:财务，2:客户，3:合同，4: 业务
 */
export const TRIGGER_TYPES = [
  TRIGGER_TYPE_FINANCE, TRIGGER_TYPE_CUSTOMER, TRIGGER_TYPE_CONTRACT, TRIGGER_TYPE_BUSINESS
]

/**
 * viewSource
 */
export const VIEW_SOURCE_APPROVAL_MATTERS = new CommonState('APPROVAL_MATTERS', '审批事项', 'approval matters')
export const VIEW_SOURCE_BILL_PAYMENT_APPLY = new CommonState('BILL_PAYMENT_APPLY', '付款申请', 'bill payment apply')

export const UNKNOWN_PROCESS_HANDLE_PASS = new CommonState(1, '未匹配到直接进行下一步操作', 'Not matched, proceed to the next step directly')
export const UNKNOWN_PROCESS_HANDLE_NOT_PASS = new CommonState(2, '未匹配到进行异常提示', 'Not matched for exception prompt')
/**
 * 未知流程处理
 */
export const UNKNOWN_PROCESS_HANDLE = new Set([
  UNKNOWN_PROCESS_HANDLE_PASS, UNKNOWN_PROCESS_HANDLE_NOT_PASS
])

export const VERIFICATION_0 = new CommonState(0, '不核销', 'Not matched, proceed to the next step directly')
export const VERIFICATION_1 = new CommonState(1, '自动核销', 'Not matched for exception prompt')

export const VERIFICATION_LIST = new Set([
  VERIFICATION_0, VERIFICATION_1
])

export const RULE_CONDITIONS_NONE = new CommonState(1, '无条件', 'Unconditional')
export const RULE_CONDITIONS_ONE = new CommonState(2, '满足其一', 'Satisfy one of them')
export const RULE_CONDITIONS_ALL = new CommonState(3, '全部满足', 'All satisfied')
/**
 * 规则条件
 */
export const RULE_CONDITIONS = new Set([
  RULE_CONDITIONS_NONE, RULE_CONDITIONS_ONE, RULE_CONDITIONS_ALL
])

export const FIRST_NODE_NEED_RESOLVE = new CommonState(1, '首节点处理后，其余均自动同意', 'After the first node is processed, the rest automatically agree')
export const CONTINUOUS_NODE_SKIP_RESOLVE = new CommonState(2, '仅连续处理时自动同意', 'Automatically agree on continuous processing only')
export const EVERY_NODE_NEED_RESOLVE = new CommonState(3, '每个节点任务都需处理', 'Each node task needs to be processed')

/**
 * 快速审批模式
 */
export const QUICK_APPROVAL_MODE = new Set([
  FIRST_NODE_NEED_RESOLVE, CONTINUOUS_NODE_SKIP_RESOLVE, EVERY_NODE_NEED_RESOLVE
])

/**
 * 来源
 * @type {CommonState}
 */
export const VIEW_SOURCE_INITIATE_ALL = new CommonState('initiateAll', '我发起-全部', 'initiateAll')
export const VIEW_SOURCE_INITIATE_PROCESSING = new CommonState('initiateProcessing', '我发起-处理中', 'initiateProcessing')
export const VIEW_SOURCE_INITIATE_COMPLETED = new CommonState('initiateCompleted', '我发起-已完成', 'initiateCompleted')
export const VIEW_SOURCE_INITIATE_REVOKED = new CommonState('initiateRevoked', '我发起-已撤销', 'initiateRevoked')
export const VIEW_SOURCE_HANDLE_ALL = new CommonState('handleAll', '我处理-全部', 'handleAll')
export const VIEW_SOURCE_HANDLE_TODO = new CommonState('handleTodo', '我处理-待处理', 'handleTodo')
export const VIEW_SOURCE_HANDLE_COMPLETED = new CommonState('handleCompleted', '我处理-已完成', 'handleCompleted')

/**
 * 类型：look：我发起的、approve：我处理的
 * @type {CommonState}
 */
export const WORKFLOW_TYPE_LOOK = new CommonState('look', '我发起的', 'look')
export const WORKFLOW_TYPE_APPROVE = new CommonState('approve', '我处理的', 'approve')

/**
 * 类型：look：我发起的、approve：我处理的
 * @type {CommonState}
 */
export const Action_Type_Submit = new CommonState(7000, '发起', 'Submit')
export const Action_Type_Approve = new CommonState(7001, '同意', 'Approve')
export const Action_Type_Reject = new CommonState(7002, '拒绝', 'Approve')
export const Action_Type_Undo_Action = new CommonState(7003, '撤回', 'Undo Action')
export const Action_Type_Rollback_Process = new CommonState(7004, '撤销', 'Rollback Process')
export const Action_Type_Transfer = new CommonState(7005, '移交审核人', 'Transfer')
export const Action_Type_Return = new CommonState(7006, '退回', 'Return')
export const Action_Type_Auto_Approve = new CommonState(7007, '自动同意', 'Auto Approve')
export const Action_Type_Auto_Press_To_Do = new CommonState(7008, '催办', 'Press To Do')
export const Action_Type_Delete = new CommonState(7009, '删除', 'Delete')
export const Action_Type_Cancel = new CommonState(7010, '取消', 'Cancel')
export const Action_Type_Add_Signature = new CommonState(7011, '催办', 'Add Signature')
export const Action_Type_Transfer_Signature = new CommonState(7012, '转签', 'Transfer Signature')
export const Action_Type_Appoint = new CommonState(7013, '委派', 'Appoint')
export const Action_Type_Cancel_Signature = new CommonState(7014, '取消加签', 'Cancel Signature')

// 流程节点：角色常量
export const POSITION_OPERATION = new CommonState(1, '操作', 'Operation')
export const POSITION_FIELD_OPERATION = new CommonState(2, '现场操作', 'Field Operation')
export const POSITION_CUSTOMER_SERVICE = new CommonState(3, '客服', 'Customer Service')
export const POSITION_OVERSEAS_CS = new CommonState(4, '海外客服', 'Overseas Customer Service')
export const POSITION_DOCUMENTATION = new CommonState(5, '单证', 'Documentation')
export const POSITION_SALES = new CommonState(6, '销售', 'Sales')
export const POSITION_CARGO_SALES = new CommonState(7, '揽货销售', 'Cargo Sales')
export const POSITION_CUSTOM_1 = new CommonState(8, '自定义岗位1', 'Custom Position 1')
export const POSITION_CUSTOM_2 = new CommonState(9, '自定义岗位2', 'Custom Position 2')
export const POSITION_CUSTOM_3 = new CommonState(10, '自定义岗位3', 'Custom Position 3')
export const POSITION_CUSTOM_4 = new CommonState(11, '自定义岗位4', 'Custom Position 4')
export const POSITION_CUSTOM_5 = new CommonState(12, '自定义岗位5', 'Custom Position 5')
export const POSITION_CUSTOM_6 = new CommonState(13, '自定义岗位6', 'Custom Position 6')
export const POSITION_CUSTOM_7 = new CommonState(14, '自定义岗位7', 'Custom Position 7')
export const POSITION_CASTS = new Set([
  POSITION_OPERATION, POSITION_FIELD_OPERATION, POSITION_CUSTOMER_SERVICE, POSITION_OVERSEAS_CS, POSITION_DOCUMENTATION, POSITION_SALES, POSITION_CARGO_SALES,
  POSITION_CUSTOM_1, POSITION_CUSTOM_2, POSITION_CUSTOM_3, POSITION_CUSTOM_4, POSITION_CUSTOM_5, POSITION_CUSTOM_6, POSITION_CUSTOM_7
])
